export default class {
    constructor() {
        let newPage = 1;

        document
            .querySelector("#shopOnLoad")
            ?.addEventListener("click", (e) => {
                // Prevent refresh
                e.preventDefault;
                // Change text value on button
                e.target.innerHTML = "Offers loading...";
                // Call load more
                loadMore(newPage + 1, e);
                // Increase pagination
                newPage++;
            });

        function loadMore(paged, e) {
            jQuery.ajax({
                type: "post",
                url: `${window.location.origin}/wp-admin/admin-ajax.php`,
                dataType: "json",
                data: {
                    action: "load_more_offers_shop",
                    paged,
                },
                complete: function (response) {
                    if (response.responseText != 0) {
                        jQuery(".archive-products ul.products").append(
                            response.responseText
                        );
                        e.target.innerHTML = "Load more offers";
                    } else {
                        e.target.disabled = true;
                        e.target.innerHTML = "All offers loaded";
                    }
                },
            });
        }
    }
}
